var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"counter",staticClass:"clock",staticStyle:{"margin":"2em 0 0.5vw 0"}})}
var staticRenderFns = []
export { render, staticRenderFns }